export const getLocationPromise = (): Promise<GeolocationPosition> => {
	return new Promise(function (resolve, reject) {
		navigator.geolocation.getCurrentPosition(
			(position) => resolve(position),
			(error) => reject(error)
		);
	});
};

export const getMapsLocationLink = (address: string) =>
	`https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(address)}`;
